<div *ngIf="item.sub_tasks && item.sub_tasks.length" class="mt-2">
	<div class="d-flex align-items-center">
		<div class="text-bold text-large flex-weight-1">{{item.sub_task_count === 1 ? 'Subtask': 'Subtasks'}}</div>
		<div *ngIf="!item.group_by">
			<div class="d-flex mb-2">
				<ui-tabs [tabs]="tabs" (tabSelected)="onTabSelected($event)" [activeTab]="tab"></ui-tabs>
			</div>
		</div>
	</div>

	<table class="table table-hover vam m-0 bg-white p-2">
		<tbody>
			<ng-container *ngFor="let group of item.sub_tasks; let firstGroup = first; let i = index" class="mb-2">
				<tr *ngIf="item.group_by" class="selectable" [ngClass]="{ 'no-border': firstGroup }" (click)="toggleSubtaskExpanded(i+1); $event.stopPropagation();">
					<td class="py-2 pl-0 text-bold" colspan="3">
						<i class="text-large wq" [ngClass]="{'wq-caret-up': !isSubtaskExpanded(i+1), 'wq-caret-down': isSubtaskExpanded(i+1)}"></i>
						{{(group.group_key === 'null') ? 'Unassigned' : group.group_key}}
					</td>
					<td colspan="2">
						<span *ngIf="getStatusCount(group.sub_tasks, 'follow_up') > 0" style="font-size: 0.8rem;" class="text-warning"><i class="wq wq-task-follow-up text-warning"></i> {{getStatusCount(group.sub_tasks, 'follow_up')}} Follow Up Subtask{{getStatusCount(group.sub_tasks, 'follow_up') === 1 ? '' : 's'}}</span>
					</td>
					<td colspan="2">
						<span style="font-size: 0.7rem;" class="badge bg-success-25 text-success mr-2 p-2">{{getStatusCount(group.sub_tasks, 'completed')}} / {{group.sub_tasks.length}} </span>Subtasks Completed
					</td>
					<td colspan="2">
						<ng-container *ngIf="group.dependencies?.length">
							<i class="wq wq-dependency-photo" [ngbTooltip]="'Dependencies'" [ngClass]="{ 'text-primary': getCompletedDependencies(group.dependencies) > 0, 'text-secondary': getCompletedDependencies(group.dependencies) === 0 }"></i>
							<span class="text-small text-secondary">
								<ng-container *ngIf="group.dependencies?.length">
									<span [ngClass]="{'text-primary': getCompletedDependencies(group.dependencies) > 0}">
										{{ getCompletedDependencies(group.dependencies) }}
									</span>
									<span [ngClass]="{ 'text-secondary': group.dependencies?.length === 0, 'text-primary': getCompletedDependencies(group.dependencies) === group.dependencies?.length && group.dependencies?.length > 0 }">/</span>
								</ng-container>
								<span [ngClass]="{ 'text-secondary': group.dependencies?.length === 0, 'text-primary': getCompletedDependencies(group.dependencies) === group.dependencies?.length && group.dependencies?.length > 0 }">
									{{ group.dependencies?.length || 0 }}
								</span>
							</span>
						</ng-container>
					</td>
				</tr>
				<ng-container *ngIf="isSubtaskExpanded(i+1) || !item.group_by">
					<ng-container *ngFor="let subtask of group.sub_tasks; let firstTask = first">
						<tr [ngClass]="{ 'no-border': firstTask, 'table-warning': subtask.stage === 'follow_up' }">
							<td class="shrink pr-0 selectable" (click)="toggleSubtaskStage(subtask)" *ngIf="subtask.stage !== 'follow_up'">
								<div [ngClass]="{'border': subtask.stage !== 'completed'}" class="rounded-circle d-flex align-items-center" [ngStyle]="{'background-color': subtask.stage === 'completed' ? '#58AE94' : '#FFFFFF'}" style="color: #FFFFFF; width: 1rem; height: 1rem; font-size: 0.5rem;">
									<i style="margin: 0 auto;" [ngClass]="{'wq-check': subtask.stage === 'completed', 'wq': true}"></i>
								</div>
							</td>
							<td class="shrink pr-0" *ngIf="subtask.stage === 'follow_up'">
								<i class="wq wq-task-follow-up text-warning text-large"></i>
							</td>
							<td class="shrink pr-0">
								<div *ngIf="subtask.image_url" class="product-image w-2r h-2r my-n1" [style.backgroundImage]="'url(\'' + subtask.image_url + '\')' | safeStyle"></div>
							</td>
							<td><span class="text-lines lines-1 text-bold" uiEllipsisTooltip>{{subtask.name}}</span></td>
							<td>
								<span class="text-lines lines-1" uiEllipsisTooltip [innerHTML]="subtask.description | linky"></span>
								<div class="d-flex align-items-center mt-1">
									<div *ngIf="subtask.dependencies.length">
										<span [ngClass]="{ 'selectable hoverable': editable && hasCompletedDependencies(subtask) }" (click)="toggleDependencies(subtask)">
											<i *ngFor="let d of subtask.dependencies" class="wq wq-dependency-{{d.type}} mr-2 text-large {{d.done ? 'text-primary' : 'text-silver'}}" [ngbTooltip]="d.name"></i><i *ngIf="editable && hasCompletedDependencies(subtask)" class="wq wq-caret-{{subtask.showDependencies ? 'down' : 'right'}} text-dark text-large"></i>
											<span *ngIf="editable && !hasCompletedDependencies(subtask)" class="btn-outline-secondary border-0 px-1 selectable rounded mr-2 text-uppercase" (click)="addDependency.emit(subtask)"><i class="wq wq-add mr-1"></i>Add</span>
										</span>
									</div>
									<div *ngIf="subtask.notes?.length" class="d-flex align-items-center selectable ml-2" (click)="openTaskNotes(subtask)">
										<i class="wq wq-notes text-primary mr-2"></i>
										<div class="text-lines lines-1 text-secondary" style="max-width: 20rem;" uiEllipsisTooltip>{{subtask.notes[0]?.note}}</div>
										<div *ngIf="subtask.notes.length > 1" class="ml-2 text-secondary nowrap flex-weight-0">(+{{subtask.notes.length -1}} note{{subtask.notes.length - 1 === 1 ? '' : 's'}})</div>
									</div>
									<div *ngIf="!subtask.notes?.length" class="btn-outline-secondary d-flex align-items-center selectable ml-1 p-1 rounded" (click)="openTaskNotes(subtask)">
										<i class="wq wq-notes mr-2"></i> Add Note
									</div>
									<div *ngIf="subtask.stock_variation && subtask.stock_variation.length" class="px-1 text-bold mr-2 rounded ml-1 d-inline" [ngbTooltip]="subtask.stock_variation" style="background-color: #FFF2AE;"><i class="wq wq-warning mr-2 text-warning"></i>Stock Variation</div>
								</div>
							</td>
							<td class="text-right shrink pr-0">
								<span *ngIf="subtask.billable" class="badge badge-info">Billable</span>
							</td>
							<td class="text-right shrink nowrap pr-0">{{ subtask.duration || 0 | hours }}</td>
							<td class="text-right">
								<div class="d-flex align-items-center flex-row-reverse flex-wrap">
									<span *ngIf="subtask.area && group.group_key !== subtask.area" class="max-width-7 badge badge-lightgrey text-no-transform text-normal mr-1 mt-1"><span class="text-lines lines-2" uiEllipsisTooltip>{{subtask.area}}</span></span>
									<span *ngIf="subtask.category && group.group_key !== subtask.category" class="max-width-7 badge badge-lightgrey text-no-transform text-normal mr-1 mt-1"><span class="text-lines lines-2" uiEllipsisTooltip>{{subtask.category}}</span></span>
									<ng-container *ngFor="let labour_type of subtask.labour_types">
										<span class="max-width-7 badge badge-light border border-lightgrey text-no-transform text-normal mr-1 mt-1"><span class="text-lines lines-2" uiEllipsisTooltip>{{labour_type}}</span></span>
									</ng-container>
								</div>
							</td>
							<td><ui-task-priority [priority]="subtask.priority"></ui-task-priority></td>
							<td *ngIf="editable" class="shrink">
								<div class="d-flex">
									<button class="btn btn-outline-secondary btn-sm border-0 px-1" (click)="edit(subtask)"><i class="wq wq-edit"></i></button>
									<button *ngIf="item.work_order_no || subtask.stage === 'follow_up'" class="btn btn-outline-secondary btn-sm border-0 px-1 ml-1 dropdown-toggle" data-toggle="dropdown"><i class="wq wq-more"></i></button>
									<div class="dropdown-menu">
										<button *ngIf="subtask.stage === 'follow_up'" class="dropdown-item dropdown-item-success" (click)="markFollowUp(subtask)">Resolve Follow Up</button>
										<button *ngIf="subtask.stage !== 'follow_up' && item.work_order_no" class="dropdown-item dropdown-item-warning" (click)="markFollowUp(subtask)">Mark As Follow Up</button>
									</div>
								</div>
							</td>
						</tr>
						<tr *ngIf="editable && subtask.showDependencies" class="no-border">
							<td colspan="8" class="bg-white" style="position: relative; height: 5rem;">
								<div class="scrollable w-100 pl-4" style="position: absolute; top: 0; left: 0; right: 0;">
									<div class="d-flex align-items-center">
										<div *ngFor="let d of subtask.dependencies | manglerFilter:{done:1}" class="p-1 rounded selectable hoverable" (click)="clickDependency.emit(d)">
											<div class="d-flex align-items-center">
												<div *ngIf="d.image_url" class="w-4r h-4r border border-4 border-lightgrey rounded product-image image-container" style="background-size: cover;" [style.backgroundImage]="'url(\'' + d.image_url + '\')' | safeStyle">
													<div class="dependency-count badge-light p-1" *ngIf="d.image_data?.image_id.length > 1">
														<i class="wq wq-camera mr-1"></i>
														{{d.image_data.image_id.length}}
													</div>
												</div>
												<div *ngIf="!d.image_url" class="w-4r h-4r border border-4 border-lightgrey rounded p-1 text-pre text-tiny overflow-hidden bg-white">{{d.text_content}}</div>
												<div class="text-small w-8r ml-2">
													<div class="text-lines lines-1" uiEllipsisTooltip><i class="wq wq-dependency-{{d.type}} mr-1 text-large text-primary"></i> <span class="text-secondary">{{d.name}}</span></div>
													<div class="text-lines lines-1 text-bold" uiEllipsisTooltip>{{d.user_name}}</div>
													<div class="text-lines lines-1 text-tiny text-secondary" uiEllipsisTooltip>{{d.completed_datetime | mySQLDateToISO | localizedDate:'shortDate'}} {{d.completed_datetime | mySQLDateToISO | localizedDate:'shortTime'}}</div>
												</div>
											</div>
										</div>
										<span class="btn-outline-secondary border-0 p-1 selectable rounded h-20 selectable text-uppercase" (click)="addDependency.emit(subtask)">Add / Edit</span>
									</div>
								</div>
							</td>
						</tr>
					</ng-container>
				</ng-container>
			</ng-container>
		</tbody>
	</table>
</div>
